import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import "./../../assest/css/preview.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { numberFormat } from "../../utils/utils";

export default function Preview() {
  const bookings = useSelector((state) => state.booking, shallowEqual);
  const dispatchItem = useSelector((state) => state.dispatchItem, shallowEqual);
  const generalInfo = useSelector((state) => state.generalInfo, shallowEqual);
  const collectorInfo = useSelector(
    (state) => state.collectorInfo,
    shallowEqual
  );

  const [balance, setBalance] = useState(0);

  // const dispatch = useDispatch();
  useEffect(() => {
    setBalance(
      Math.floor(
        bookings.avgBookingDetails.averageRate *
          (bookings.avgBookingDetails.averagePureWeight -
            dispatchItem.totalDispatchedItemDetails.totalPureWeight)
      )
    );
  }, [bookings, dispatchItem]);

  return (
    <>
      <Container fluid className="container">
        <Row>
          <Col>Om</Col>
        </Row>
        <Row>
          <Col className="title">Date :</Col>
          <Col>{generalInfo.generalInfo[0].challanDate}</Col>
          <Col className="title">Cust Name: </Col>
          <Col>{generalInfo.generalInfo[0].custName}</Col>
        </Row>
        <Row>
          <Col className="title">Rcvr. Name:</Col>
          <Col>{collectorInfo.collectorInfo[0].collectorName}</Col>
          <Col className="title">Ph. No :</Col>
          <Col>{collectorInfo.collectorInfo[0].collectorContactNumber}</Col>
          <Col className="title">Cash</Col>
          <Col>₹ {balance}</Col>
        </Row>
        <Row>
          <Col xs={5}>
            <Row>
              <Col className="heading">Booking Details </Col>
            </Row>
            <Row>
              <Col className="subheading">Rate</Col>
              <Col className="subheading">Amount</Col>
              <Col className="subheading">Pure Wt.</Col>
            </Row>
            {bookings.bookings.map(
              ({ bookingRate, bookingAmount, pureWeight }, index) => {
                return (
                  <Row key={index}>
                    <Col colSpan={2}>{bookingRate}</Col>
                    <Col colSpan={2}>{bookingAmount}</Col>
                    <Col>{pureWeight}</Col>
                  </Row>
                );
              }
            )}
            <Row>
              <Col></Col>
              <Col className="grandtotal">
                ₹ {numberFormat(bookings.avgBookingDetails.averageAmount, 2)}
              </Col>
              <Col className="grandtotal">
                {numberFormat(bookings.avgBookingDetails.averagePureWeight, 3)}{" "}
                g
              </Col>
            </Row>
          </Col>
          <Col xs={7}>
            <Row>
              <Col className="heading">Dispatch Details </Col>
            </Row>
            <Row>
              <Col className="subheading">T. No:</Col>
              <Col className="subheading">Pieces</Col>
              <Col className="subheading">Weight</Col>
              <Col className="subheading">Purity</Col>
              <Col className="subheading">Pure Wt.</Col>
            </Row>
            {dispatchItem.dispatchItemDetails.map(
              (
                { token, noOfPieces, itemWeight, itemPurity, itemPureWeight },
                index
              ) => {
                return (
                  <Row key={index}>
                    <Col>{token}</Col>
                    <Col>{noOfPieces}</Col>
                    <Col>{numberFormat(itemWeight, 3)}</Col>
                    <Col>{numberFormat(itemPurity, 2)}</Col>
                    <Col>{numberFormat(itemPureWeight, 3)}</Col>
                  </Row>
                );
              }
            )}
            <Row>
              <Col></Col>
              <Col className="grandtotal">Pieces</Col>
              <Col className="grandtotal">
                {numberFormat(
                  dispatchItem.totalDispatchedItemDetails.totalWeight,
                  3
                )}
              </Col>
              <Col></Col>
              <Col className="grandtotal">
                {numberFormat(
                  dispatchItem.totalDispatchedItemDetails.totalPureWeight,
                  3
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
